export const isFcmSupported = () => {
  if (typeof window === "undefined") return false;

  const hostname = window.location.hostname;

  const isLocalhost =
    hostname === "localhost" ||
    hostname === "127.0.0.1";

  const isIp =
    /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname) && !isLocalhost;

  if (isIp) return false;

  if (!window.isSecureContext && !isLocalhost) return false;

  if (
    !("serviceWorker" in navigator) ||
    !("PushManager" in window) ||
    !("Notification" in window)
  ) {
    return false;
  }

  return true;
};
